export const FF1Colors = {
    white: '#fff',
    black: '#000',
    lightestGray: '#F2F2F2',
    lightGray: '#CFCFCF',
    mediumGray: '#999',
    darkGray: '#3A3939',
    greenFaded: '#C1D2CF',
    orange: '#FFA12E',
}